import {CONFIRMED_GET_PATIENT_LIST} from "../actions/TokenSystemType";
import swal from "sweetalert";
import {getPatientList, formatPatients} from "../../services/TokenSystemService"
import { handleError, showErrorAlert } from "../../services/ErrorHandlingService";


export function getPatientListAction(showAlert = true) {
  return async (dispatch, getState) => {
    try {
      const response = await getPatientList();

      if (
        response &&
        response.status === 200 &&
        response.data?.status === "success"
      ) {
        const patients = formatPatients
          ? formatPatients(response.data.data)
          : response.data.data;

        //console.log("PATIENTS >> ", patients);
        dispatch({ type: CONFIRMED_GET_PATIENT_LIST, payload: patients });
      } else {
        if (showAlert) handleError("Failed to get patients: Server error");
      }
    } catch (error) {
      console.error("API Error:", error);
      if (showAlert) showErrorAlert("Failed to get patients");
    }
  };
}
